import React from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import styles from "./style.module.css";
// import "./style.css";

const AdminGrid = ({ row, cols, onGridReady, rowClass, ...rest }) => {
  return (
    <div className={`ag-theme-quartz py-3 ${styles["tableSize"]}`} {...rest}>
      <AgGridReact
        rowData={row}
        rowClass={rowClass}
        columnDefs={cols}
        onGridReady={onGridReady}
        {...rest}
      />
    </div>
  );
};

export default AdminGrid;
